import URL from "./apiURL";
import { authenticatedFetch } from "../../utils/authenticatedFetch";


export async function updateTicketStatus(payload) {
  try {
    const data = await authenticatedFetch(URL.updateTicketStatusApi, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
    return data;
  } catch (error) {
    console.error("Error updating ticket status:", error);
    throw error;
  }
}
